import { memo } from 'react';
import SectionHeading from '@bridebook/web/app-shared/components/supplier/sections/section-heading';

interface IProps {
  count: number;
  heading: string;
}

const AwardHeader = ({ count, heading }: IProps) => (
  <SectionHeading>
    {heading} ({count})
  </SectionHeading>
);

export default memo(AwardHeader);
